module.exports = __webpack_public_path__ + "static/media/id-card-front.3562f4ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/id-card-front.svg
// module id = 2423
// module chunks = 7